export const stepControllerReducer = (state, action) => {
    switch (action.type) {
        case 'setCurrentSubmit':
            return {
                ...state,
                currentSubmit: action.payload.fn,
                isContinueDisabled: action.payload.isContinueDisabled,
                isContinueLoading: action.payload.isContinueLoading,
                isBackDisabled: action.payload.isBackDisabled,
            };
        case 'setContinueDisabled':
            return { ...state, isContinueDisabled: action.payload };
        case 'setStepComplete':
            return { ...state, isStepCompleted: action.payload };
        case 'setPageErrors':
            return { ...state, pageErrors: action.payload };
        default:
            return state;
    }
};
